import { getZombieInstanceFromPrimaryKey } from '@iotv/datamodel';
import { loadable } from 'react-lazily/loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { extractViewObjectFromNodeEdgeMapper } from '../data/daoFunctions/nodeEdgeMapperTransform';
import { TransactionFunctions, UserFunctions } from '../redux/actions/AppActionFunctions/AppActions';
const ThingView = loadable(() => import('../components/ThingView/ThingView')).default;
const debug = process.env.REACT_APP_DEBUG && false;
const mapStateToProps = (state, ownProps) => {
    debug && console.log('ThingView own props', ownProps);
    const { type, id } = ownProps.params;
    const zombie = getZombieInstanceFromPrimaryKey(`${type}:${id}`);
    const extractedObject = extractViewObjectFromNodeEdgeMapper(state.AppReducer.applicationData, zombie);
    debug && console.log('ThingViewContainer', { zombie, extractedObject });
    debug && console.log('applicationData', state.AppReducer.applicationData);
    const viewObject = extractedObject ?? { matchedPrimary: undefined, matchedRelatedByPk: [], matchedRelatedBySk: [] };
    return {
        viewObject,
        applicationData: state.AppReducer.applicationData,
        thingViewMap: state.AppReducer.thingViewMap,
        contextCustomer: state.AppReducer.contextCustomer,
        user: state.AppReducer.user,
        userGroupRoles: state.AppReducer.userGroupRoles,
        userSelectedGroup: state.AppReducer.userSelectedGroup,
        useSpecializedViews: state.AppReducer.useSpecializedViews,
        roleArbitrationInstance: state.AppReducer.roleArbitrationInstance,
        isSmallView: state.AppReducer.isSmallView,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        init: (cognitoUser, userGroupRoles) => {
            debug && console.log('ThingView Container requested init', ownProps);
        },
        userFunctions: bindActionCreators(UserFunctions, dispatch),
        transactionFunctions: bindActionCreators(TransactionFunctions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ThingView);
